<template>
  <v-btn
    :text="hasLabel"
    :rounded="hasLabel"
    :outlined="hasLabel"
    :icon="hasIcon && !hasLabel"
    :disabled="disabled"
    @click="$emit('click')"
  >
    <v-icon v-if="hasIcon" v-text="icon" :left="hasLabel"></v-icon>
    {{ label }}
  </v-btn>
</template>

<script>
export default {
  name: "IconTextButton",

  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
    label: {
      type: String,
      default: null,
    },
    icon: {
      type: String,
      default: null,
    },
  },

  computed: {
    hasLabel() {
      return this.label != null && this.label != "";
    },
    hasIcon() {
      return this.icon != null && this.icon != "";
    },
  },
};
</script>
